import { Message } from 'first-intl';
import { Messages } from '../../messages';

export class WsSalutation {
    static MR = new WsSalutation('HERR', Messages.SALUTATION_MR);
    static MRS = new WsSalutation('FRAU', Messages.SALUTATION_MRS);
    static NONBINARY = new WsSalutation('DIVERS');
    static COMPANY = new WsSalutation('FIRMA');
    static UNDEFINED = new WsSalutation('UNDEFINED');

    code: string;
    message?: Message;

    constructor(code: string, message?: Message) {
        this.code = code;
        this.message = message;
    }

    static fromCode(code: string): WsSalutation {
        switch (code) {
            case 'HERR':
                return WsSalutation.MR;
            case 'FRAU':
                return WsSalutation.MRS;
            case 'DIVERS':
                return WsSalutation.NONBINARY;
            case 'FIRMA':
                return WsSalutation.COMPANY;
            default:
                return WsSalutation.UNDEFINED;
        }
    }
}
